module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"loadingMessage":"Daten werden geladen. Dies kann lange dauern, wenn viele Liegenschaften und Szenarien geladen werden müssen.","errorMessage":"Beim Laden der Daten ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."}}')
  delete Component.options._Ctor
}
